const route = [
    {//教师发作业同步习题、单元复习选择章节
        //type: 0同步习题  1单元复习
        path: '/chinese/select_task/select_chapter/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/chinese/selectTask/select_chapter.vue'], resolve);
        }
    },
    {//教师发作业同步习题、单元复习选择试卷
        //type: 0同步习题  1单元复习
        path: '/chinese/select_task/select_paper/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/chinese/selectTask/select_paper.vue'], resolve);
        }
    },

    {//教师发作业同步习题、单元复习、高频错题选择试题
        //type: 0同步习题  1单元复习  4高频错题  
        path: '/chinese/select_task/select_test/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/chinese/selectTask/select_test.vue'], resolve);
        }
    },
    {//教师发作业同步习题、单元复习试题预览
        //paper_id: 试卷id
        path: '/chinese/select_task/preview/:paper_id',
        component: function (resolve) {
            require(['VIEWS/chinese/selectTask/preview.vue'], resolve);
        }
    },
    {//高频错题首页
        path: '/chinese/wrong/index',
        component: function (resolve) {
            require(['VIEWS/chinese/wrong/index'], resolve);
        }
    },
    {//课文预习选章节
        path: '/chinese/before/taskset',
        component: function (resolve) {
            require(['VIEWS/chinese/chinese/before/taskset.vue'], resolve);
        },
    },
    {//生词听写选章节
        path: '/chinese/listen/taskset',
        component: function (resolve) {
            require(['VIEWS/chinese/chinese/listen/taskset'], resolve);
        }
    },
    {//课文预习预览发布
        //path: '/chinese/before/preview/:gradeid',
        path: '/chinese/before/preview/:gradeid/:code/:value',
        component: function (resolve) {
            require(['VIEWS/chinese/chinese/before/preview'], resolve);
        }
    },
    { //课文预习预览课文梳理预览
        path: '/chinese/before/combing',
        component: function (resolve) {
            require(['VIEWS/chinese/chinese/before/combing'], resolve);
        }
    },
    {//生词听写选章节
        path: '/chinese/listen/taskset',
        component: function (resolve) {
            require(['VIEWS/chinese/chinese/listen/taskset'], resolve);
        }
    },
    {//生词听写选作业预览发布
        path: '/chinese/listen/preview/:type',
        component: function (resolve) {
            require(['VIEWS/chinese/chinese/listen/preview'], resolve);
        }
    },
];
export default route
